import type {OfficeType} from '~/utils/types/account/offices/types'

export const initOffice = (): OfficeType => ({
    name: {},
    countryId: null,
    cityId: null,
    locationType: null,
    airportCode: null,
    active: true,
    street: {},
    zip: null,
    latitude: null,
    longitude: null,
    contactPerson: {},
    phones: ['', '', ''],
    fax: null,
    hoursOfWork: null,
    comments: null,
})
